// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vibeoff-base -> lineups-inc-vibeoff-base -> angular-tin
// Generated: 2026-10-20T04:48:16.798Z
// Counts: 0 design, 12 content, 34 slot group, 0 collection binding, 0 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Spend summer afternoons at the saltwater pool with underwater sound, grill in the courtyard, train in the 24-hour fitness center and yoga/spin room, or get together over billiards and shuffleboard in the resident lounge. At home, you get quartz countertops, in-home washers and dryers, walk-in closets, and included garage parking. See them all on the <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Resort-style amenities in Automobile Alley</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>From the saltwater pool and grill courtyard to the fitness center, spin room, and game-ready clubhouse, Metropolitan's shared spaces keep downtown living easy all week long.</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Loft-Style Apartments in Downtown OKC's Automobile Alley</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open home at Metropolitan, floor by floor.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Neon-lit storefronts, murals, breweries, and patio dining fill the blocks around Broadway, and the OKC Streetcar makes it easy to get to downtown offices, Bricktown, Deep Deuce, Midtown, and Scissortail Park. Get to know the area on our <a href=\"/neighborhood\">neighborhood page</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Live where Broadway's Automobile Alley comes alive</p>",
    "mappedField": null
  },
  "nextstep.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Studio to three-bedroom apartments and two-story lofts with oversized windows, quartz countertops, and included garage parking, starting from $1,288. 25 homes are ready to move in now.</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Metropolitan makes city life easy for pets, with an on-site pet play area for quick outdoor breaks and a pet washing station for cleanup after a walk. Automobile Alley's sidewalks and nearby Scissortail Park give you plenty of room for longer outings. See the full <a href=\"/pet-policy\">pet policy</a> for details.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Bring your best friend downtown</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through the NYC, Los Angeles, San Antonio, Chicago, Phoenix, Dallas, Sacramento, Seattle, Las Vegas, San Diego, and Charlotte plans in our <a href=\"/virtual-tours\">3D tours</a>, then see Metropolitan in person on a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Choose from 11 video walkthroughs of Metropolitan floor plans, from one-bedroom layouts like the NYC, Chicago, and Phoenix to the two-bedroom Seattle and San Diego, the 1,214-square-foot Las Vegas, and the three-bedroom Charlotte, then compare them all on our <a href=\"/floor-plans\">floor plans</a> page.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c2c6-7640-b480-f8a80beb3c79.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings."
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-cde3-714d-bcc8-0fda8361da30.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Vibrant lounge area with modern furniture and motivational wall art."
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-711c-70a3-9615-9356b831ce19.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with bar stools."
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c2c6-7640-b480-f8a80beb3c79.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Saltwater Pool"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d951-703d-9bed-5611e4d12631.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard with fountain, lounge chairs, and outdoor grills."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-cdaa-7033-bc45-d2a67dcd3194.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "State-of-the-art fitness center with treadmills, ellipticals, rowing machines, and weight-lifting equipment."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-cc88-77dc-987b-180e85948fff.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spin bikes and TRX suspension trainers in a modern fitness center."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Spin Room"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c431-749a-b847-7d86d023fc5b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community lounge area with a pool table, shuffleboard, and seating."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d23e-7106-aaca-eec3231fd861.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern lobby with stylish seating areas and a reception desk with \"Metropolitan\" branding."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Lobby"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-711c-70a3-9615-9356b831ce19.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with bar stools."
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-cdaa-7033-bc45-d2a67dcd3194.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "State-of-the-art fitness center with treadmills, ellipticals, rowing machines, and weight-lifting equipment."
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d68b-7259-a6ec-5bec357f0de1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "The Metropolitan apartment building's modern exterior with balconies and a prominent entrance."
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-b590-72f5-bf5c-8830a83eacf9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a large window overlooking a city skyline, featuring a tan leather sofa, a coffee table, and a television."
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c2c6-7640-b480-f8a80beb3c79.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings."
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-b308-74b8-b929-f876ad0ca75b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and bedroom view of a luxury apartment with large windows and city views."
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d951-703d-9bed-5611e4d12631.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard with fountain, lounge chairs, and outdoor grills."
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d23e-7106-aaca-eec3231fd861.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern lobby with stylish seating areas and a reception desk with \"Metropolitan\" branding."
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c431-749a-b847-7d86d023fc5b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community lounge area with a pool table, shuffleboard, and seating."
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-b5c4-74ab-aa56-b87c059bd0ff.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bedroom with a king-size bed, dresser, and large window."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-2b67-77ff-aede-38bee9e660da.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Gardens and green space at Myriad Botanical Gardens in downtown Oklahoma City"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Myriad Botanical Gardens"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-8ed1-7328-a5e8-bb46cada92f0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced grassy pet play area with trees at Metropolitan."
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Pet play area"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d68b-7259-a6ec-5bec357f0de1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "The Metropolitan apartment building's modern exterior with balconies and a prominent entrance."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Exterior"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d951-703d-9bed-5611e4d12631.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard with fountain, lounge chairs, and outdoor grills."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard & Grills"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-b590-72f5-bf5c-8830a83eacf9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a large window overlooking a city skyline, featuring a tan leather sofa, a coffee table, and a television."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Living Room"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c431-749a-b847-7d86d023fc5b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community lounge area with a pool table, shuffleboard, and seating."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Resident Lounge"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-a634-7231-9ad6-9d6414e5cfe7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with island and stainless steel appliances, open to living room with large windows."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-cdaa-7033-bc45-d2a67dcd3194.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "State-of-the-art fitness center with treadmills, ellipticals, rowing machines, and weight-lifting equipment."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Responsive maintenance"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "very impressed with the maintenance team"
      }
    }
  },
  "reviewthemes.chip_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Caring staff"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "staff genuinely care about residents"
      }
    }
  },
  "reviewthemes.chip_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Community events"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "It really brings the community together"
      }
    }
  },
  "reviewthemes.chip_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Walkable location"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "plenty of things within walking distance"
      }
    }
  },
  "reviewthemes.chip_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Well kept"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "clean and well taken care of"
      }
    }
  },
  "reviewthemes.chip_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Spacious homes"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "the apartments are spacious"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d68b-7259-a6ec-5bec357f0de1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "The Metropolitan apartment building's modern exterior with balconies and a prominent entrance."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {};

export const styleOverrides = {};
